export default function FallbackUI() {
  return (
    <div className="bg-white dark:bg-gray-800">
      <div className="animate-pulse">
        <div className="w-screen h-screen bg-slate-300 dark:bg-slate-700" />
      </div>
    </div>
  );
}
